<template>
  <div>
    <div class="sixteentosix omt-6 omt-md-25 sixteentosix-wrap">
      <div class="new-background-wrap">
        <div
          class="kachelimage header-image zoom-image"
          style="
            background: url('/static/img/default_header.png');
            background-position: top !important;
          "
        ></div>
        <div class="headline-wrap">
          <div class="headline">
            <div class="text-subtitle-2 text-md-h5">
              {{ $t("contactpersons") }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <Breadcrumb />
    <div>
      <div class="mx-0 row align-items-start cp_wrapper cp_wrapper_new">
        <!-- Left Area -->
        <div class="col-xl-9 px-0">
          <div class="mx-0 pa-0 text-content">
            <v-expansion-panels v-model="open" multiple>
              <div class="cp_wrap">
                <v-expansion-panel
                  v-for="(tenant, i) in visibleTenants"
                  :key="i"
                  class="py-1 pl-8 pl-md-12"
                >
                  <v-expansion-panel-header class="py-1 pl-8 pl-md-12">
                    <h6 class="text-md-h6 mb-0">
                      {{ tenant.name }}
                    </h6>
                    <template v-slot:actions>
                      <div>
                        <img
                          :class="
                            open === i ? 'panelarrow_up' : 'panelarrow_down'
                          "
                          class="ml-2 clickable"
                          src="../assets/img/arrow_right.svg"
                          height="18px"
                          alt="arraow"
                        />
                      </div>
                    </template>
                  </v-expansion-panel-header>
                  <v-expansion-panel-content>
                    <div class="d-flex g-space-15">
                      <!-- Head Office -->
                      <div
                        class="col-xl-12 col-md-6 p-0"
                        v-show="tenant.contactPersons.headOffice.length > 0"
                      >
                        <h4>{{ $t("head_office") }}</h4>
                      </div>
                      <div
                        class="trainer-block col-md-6 justify-content-center p-0"
                        v-for="contactPerson in tenant.contactPersons
                          .headOffice"
                        :key="contactPerson.id"
                      >
                        <div class="block-tile col-md-12 sixteentonine">
                          <div
                            class="block-tile kachelimage block-background-image cpImageWrapper"
                            :style="{
                              'background-image':
                                'url(\'/files/images/' +
                                contactPerson.trainerImage +
                                '\')',
                            }"
                          ></div>
                          <div class="bg-blue cpNameWrapper">
                            <h4>{{ contactPerson.fullname }}</h4>
                            <p v-if="contactPerson.designation">
                              {{ contactPerson.designation }}
                            </p>
                          </div>
                          <div class="cpDetailWrapper">
                            <div class="cpMainImgWrap">
                              <img
                                :src="
                                  '/files/images/' + contactPerson.trainerImage
                                "
                                alt="Trainer Image"
                              />
                            </div>
                            <div class="cpCardLeft">
                              <div v-if="contactPerson.company">
                                {{ contactPerson.company }}
                              </div>
                              <div
                                v-if="
                                  tenant.addressFormattedSingleLineWithCountry
                                "
                              >
                                {{
                                  tenant.addressFormattedSingleLineWithCountry
                                }}
                              </div>
                              <div v-if="contactPerson.personnelnumber">
                                Tel:
                                <a
                                  :href="'tel:' + contactPerson.personnelnumber"
                                  >{{ contactPerson.personnelnumber }}</a
                                >
                              </div>
                              <div v-if="contactPerson.email">
                                <a :href="'mailto:' + contactPerson.email">{{
                                  contactPerson.email
                                }}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Trainers -->
                      <div
                        class="col-xl-12 col-md-6 p-0"
                        v-show="tenant.contactPersons.trainers.length > 0"
                      >
                        <h4>{{ $t("trainer_contact") }}</h4>
                      </div>
                      <div
                        class="trainer-block col-md-6 justify-content-center p-0"
                        v-for="contactPerson in tenant.contactPersons.trainers"
                        :key="contactPerson.id"
                      >
                        <div class="block-tile col-md-12 sixteentonine">
                          <div
                            class="kachelimage block-background-image cpImageWrapper"
                            :style="{
                              'background-image':
                                'url(\'/files/images/' +
                                contactPerson.trainerImage +
                                '\')',
                            }"
                          ></div>
                          <div class="bg-blue cpNameWrapper">
                            <h4>{{ contactPerson.fullname }}</h4>
                            <p v-if="contactPerson.designation">
                              {{ contactPerson.designation }}
                            </p>
                          </div>
                          <div class="cpDetailWrapper">
                            <div class="cpMainImgWrap">
                              <img
                                :src="
                                  '/files/images/' + contactPerson.trainerImage
                                "
                                alt="Trainer Image"
                              />
                            </div>
                            <div class="cpCardLeft">
                              <div v-if="contactPerson.company">
                                {{ contactPerson.company }}
                              </div>
                              <div
                                v-if="
                                  tenant.addressFormattedSingleLineWithCountry
                                "
                              >
                                {{
                                  tenant.addressFormattedSingleLineWithCountry
                                }}
                              </div>
                              <div v-if="contactPerson.personnelnumber">
                                Tel:
                                <a
                                  :href="'tel:' + contactPerson.personnelnumber"
                                  >{{ contactPerson.personnelnumber }}</a
                                >
                              </div>
                              <div v-if="contactPerson.email">
                                <a :href="'mailto:' + contactPerson.email">{{
                                  contactPerson.email
                                }}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Others -->
                      <div
                        class="col-xl-12 col-md-6 p-0"
                        v-show="tenant.contactPersons.others.length > 0"
                      >
                        <h4>{{ $t("contactpersons") }}</h4>
                      </div>
                      <div
                        class="trainer-block col-md-6 justify-content-center p-0"
                        v-for="contactPerson in tenant.contactPersons.others"
                        :key="contactPerson.id"
                      >
                        <div class="block-tile col-md-12 sixteentonine">
                          <div
                            class="kachelimage block-background-image cpImageWrapper"
                            :style="{
                              'background-image':
                                'url(\'/files/images/' +
                                contactPerson.trainerImage +
                                '\')',
                            }"
                          ></div>
                          <div class="bg-blue cpNameWrapper">
                            <h4>{{ contactPerson.fullname }}</h4>
                            <p v-if="contactPerson.designation">
                              {{ contactPerson.designation }}
                            </p>
                          </div>
                          <div class="cpDetailWrapper">
                            <div class="cpMainImgWrap">
                              <img
                                :src="
                                  '/files/images/' + contactPerson.trainerImage
                                "
                                alt="Trainer Image"
                              />
                            </div>
                            <div class="cpCardLeft">
                              <div v-if="contactPerson.company">
                                {{ contactPerson.company }}
                              </div>
                              <div
                                v-if="
                                  tenant.addressFormattedSingleLineWithCountry
                                "
                              >
                                {{
                                  tenant.addressFormattedSingleLineWithCountry
                                }}
                              </div>
                              <div v-if="contactPerson.personnelnumber">
                                Tel:
                                <a
                                  :href="'tel:' + contactPerson.personnelnumber"
                                  >{{ contactPerson.personnelnumber }}</a
                                >
                              </div>
                              <div v-if="contactPerson.email">
                                <a :href="'mailto:' + contactPerson.email">{{
                                  contactPerson.email
                                }}</a>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </v-expansion-panel-content>
                </v-expansion-panel>
              </div>
            </v-expansion-panels>
          </div>
        </div>

        <!-- Right Area -->
        <div class="col-xl-3 pl-8 pl-md-12 pl-xl-8 row">
          <Contact />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pagination from "./custom/pagination.vue";
import Breadcrumb from "./Breadcrumbs.vue";

export default {
  components: {
    pagination,
    Breadcrumb,
  },

  data() {
    return {
      tenants: [],
      contactPersons: [],
      open: [0], // single open panel index
    };
  },
  computed: {
    visibleTenants() {
      return this.tenants.filter((tenant) => {
        const cp = tenant.contactPersons;
        return (
          cp &&
          (cp.headOffice.length > 0 ||
            cp.trainers.length > 0 ||
            cp.others.length > 0)
        );
      });
    },
  },
  mounted() {
    this.fetchTenants();
  },

  methods: {
    onError(err) {
      if (
        err.response != null &&
        err.response.data != null &&
        err.response.data.message != null
      ) {
        this.$noty.error(err.response.data.message);
      } else {
        console.error(err);
      }
    },
    fetchTenants() {
      this.$axios
        .get("/api/tenant/public")
        .then((response) => {
          // Pre-initialize contactPersons
          this.tenants = response.data.map((tenant) => ({
            ...tenant,
            contactPersons: {
              headOffice: [],
              trainers: [],
              others: [],
            },
          }));

          // Fetch contact persons
          const fetchAllContacts = this.tenants.map((_, index) =>
            this.fetchContactPersons(index)
          );
        })
        .catch(this.onError);
    },
    fetchContactPersons(tenantIndex) {
      const tenantId = this.tenants[tenantIndex].id;
      let _this = this;
      return this.$axios
        .get("/api/user/public/" + tenantId)
        .then((response) => {
          const contactPersons = response.data;

          const headOffice = [];
          const trainers = [];
          const others = [];

          for (const contactPerson of contactPersons) {
            if (contactPerson.headOffice) {
              headOffice.push(contactPerson);
            } else if (contactPerson.trainer) {
              trainers.push(contactPerson);
            } else {
              others.push(contactPerson);
            }
          }

          // Update the contactPersons of the corresponding tenant
          _this.tenants[tenantIndex].contactPersons = {
            headOffice,
            trainers,
            others,
          };
        })
        .catch(this.onError);
    },
  },
};
</script>
